import React from 'react';

const SchoolSvg = () => (
  <svg
    width="147"
    height="147"
    viewBox="0 0 147 147"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M73.5 136.5C108.294 136.5 136.5 108.294 136.5 73.5C136.5 38.706 108.294 10.5 73.5 10.5C38.706 10.5 10.5 38.706 10.5 73.5C10.5 108.294 38.706 136.5 73.5 136.5Z"
      fill="#D8D8D8"
    />
    <circle cx="73.5" cy="73.5" r="60.5" fill="white" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M74.6731 48.9935C111.518 47.4843 111.842 61.6073 113.486 69.887C115.129 78.1655 113.7 102.771 113.7 102.771C113.7 102.771 108.95 88.4005 93.5404 79.6286C77.9802 70.7713 38.7434 74.8066 27 46C27 46 37.3267 50.5226 74.6731 48.9935ZM36.4676 63.0334C36.4676 63.0334 37.7004 70.0482 72.3263 76.3703C104.166 82.1833 111.882 102.771 111.882 102.771C111.882 102.771 94.9255 94.2353 70.4219 89.6806C53.0586 86.4525 47.7584 85.0289 36.4676 63.0334ZM106.86 102.771C87.2604 102.771 66.1695 106.41 48.7462 84.6894C62.5256 94.5741 75.8847 90.1945 106.86 102.771Z"
      fill="#C6C6C6"
    />
  </svg>
);

export default SchoolSvg;
